export default {
  "logoLink": "https://www.atfx.com/uk/hi/",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "FCA License No",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "लाइव फ़ॉरेक्स और सीएफडी ट्रेडिंग अकाउंट ओपन करें | ATFX यूके",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Spread bets and CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading CFDs. You should consider whether you can afford to take the high risk of losing your money.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38% of retail investor accounts lose money when trading CFDs / Spread betting with this provider.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "यूके FCA विनियमित ब्रोकर के साथ ATFX फॉरेक्स और सीएफडी लाइव अकाउंट ओपन करें। कम स्प्रेड, लीवरेज 1: 200, MT4 प्लेटफॉर्म, 24/5 कस्टमर सपोर्ट। अभी अकाउंट साइन अप करें!",
  "policyBarClose": 'The Firm has taken the decision to cease providing services to retail clients, with immediate effect. We are therefore unable to accept any applications.<br />Services to professional clients will not be impacted. For professional applications please contact <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'We use cookies to ensure you get the best experience on our website. By continuing to browse you accept our use of cookies. <a title="[Read more]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Read more]</a>',
  "policyBarButton":'Accept',
  "header": {
    "registration": "अकाउंट ओपनिंग",
    "personalDetails1": "व्यक्तिगत विवरण 1",
    "personalDetails2": "व्यक्तिगत विवरण 2",
    "financialDetails": "वित्तीय विवरण",
    "Experience": "अनुभव",
    "Knowledge": "ज्ञान",
    "Acknowledgements": "पुष्टि",
    "previewPage":"पूर्वावलोकन",
    "liveTrading": "LIVE TRADING"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. All rights reserved.",
    "terms1":"Privacy Polic",
    "terms2":"Cookies Policy",
    "terms3":"Terms and Conditions",
    "Legal":"Legal: AT Global Markets (UK) Limited is authorised and regulated by the Financial Conduct Authority (FCA) in the United Kingdom. FCA registration number (760555). Registered Office: 1st Floor, 32 Cornhill, London EC3V 3SG,United Kingdom. Company No. 09827091",
    "riskWaring":'HIGH RISK INVESTMENT WARNING: CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. <strong>59.38% of retail investor accounts lose money when trading CFDs with this provider. </strong>You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. Please read the full <a title=" Risk Disclosure Policy" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Risk Disclosure Policy</a>.',
    "otherInfo":"The information on this site is not directed at residents of the United States, Belgium or any particular country outside the UK and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation."
  },
  "headerMsg": {
    "personalDetails1": "व्यक्तिगत विवरण 1",
    "personalDetails2": "व्यक्तिगत विवरण 2",
    "financialDetails": "वित्तीय विवरण",
    "experience": "अनुभव",
    "knowledge": "ज्ञान",
    "acknowledgements": "पुष्टि"
  },
  "changeLanguage": "भाषा बदलें",
  "back": "वापस",
  "next": "आगे",
  "finish": "समाप्त",
  "personalDetails1": {
    "estimatedTime":"Estimated time to complete your registration is 5 minutes",
    "Gender": "लिंग",
    "genderSelect": {
      "M": "श्री",
      "F": "सुश्री",
      "O":"अन्य"
    },
    "OtherGender":"अन्य लिंग",
    "Title": "शीर्षक",
    "titleSelect":{
      "Mr":"श्री",
      "Mrs":"श्रीमती",
      "Ms":"सुश्री",
      "Miss":"कुमारी र",
      "Dr":"डॉ",
      "Other":"अन्य"
    },
    "OtherTitle":"अन्य शीर्षक",
    "First_Name": "पहला नाम",
    "Surname": "उपनाम",
    "Email": "ईमेल",
    "Email_Confirm": "ईमेल की पुष्टि",
    "Lang": "ईमेल की भाषा",
    "emailLanguages": {
      "ENG": "अंग्रेजी",
      "CHT": "पारंपरिक चीनी",
      "CHS": "सरलीकृत चीनी",
      "ARA": "अरबी",
      "ESP": "स्पैनिश",
      "ITA": "इटैलियन",
      "GER": "German",
      "PTG": "Portuguese"
    },
    "MT4_Currency":"ट्रेडिंग खाता मुद्रा",
    "MT4CurrencySelect":{
      "USD":"(USD) डॉलर",
      "GBP":"(GBP) पाउंड",
      "EUR":"(EUR) यूरो"
    },
    "Account_Type": "MT4 Account Type",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "सट्टेबाजी फैलाना"
    },
    "Country": "निवास का देश",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR":"यूनाइटेड किंगडम",
      "CHN":"चीन",
      "TWN":"ताइवान",
      "ARE":"संयुक्त अरब अमीरात",
      "ALB":"अल्बानिया",
      "AND":"अंडोरा",
      "AIA":"एंगुइला",
      "ATG":"अंतिगुया और बार्बूडा",
      "ARG":"अर्जेंटीना",
      "ARM":"आर्मीनिया",
      "ABW":"अरूबा",
      "AUS":"ऑस्ट्रेलिया",
      "AUT":"ऑस्ट्रिया",
      "AZE":"आजरबैजान",
      "BHS":"बहामा",
      "BHR":"बहरीन",
      "BGD":"बांग्लादेश",
      "BRB":"बारबाडोस",
      "BLR":"बेलारूस",
      "BEL":"बेल्जियम",
      "BLZ":"बेलीज",
      "BEN":"बेनिन",
      "BMU":"बरमूडा",
      "BOL":"बोलीविया",
      "BWA":"बोत्सवाना",
      "BVT":"बुवे द्वीप",
      "BRA":"ब्राजील",
      "BRN":"ब्रुनेई दारुसलाम",
      "BGR":"बुल्गारिया",
      "BFA":"बुर्किना फासो",
      "BDI":"बुरून्डी",
      "KHM":"कंबोडिया",
      "CMR":"कैमरून",
      "CPV":"केप वर्डे",
      "CYM":"केमैन टापू",
      "CAF":"सेंट्रल अफ्रीकन गणराज्य",
      "TCD":"कैड",
      "CHL":"चिली",
      "CCK":"कोकोस द्वीप समूह",
      "COL":"कोलम्बिया",
      "COM":"कोमोरोस",
      "COK":"कुक द्वीप समूह",
      "CRI":"कोस्टा रिका",
      "CIV":"कोट डी आइवर",
      "HRV":"क्रोएशिया",
      "CUB":"क्यूबा",
      "CYP":"साइप्रस",
      "CZE":"चेक",
      "DNK":"डेनमार्क",
      "DJI":"जिबूती",
      "DMA":"डोमिनिका",
      "DOM":"डोमिनिकन गणराज्य",
      "EGY":"मिस्र",
      "SLV":"एल साल्वाडोर",
      "ERI":"इरिट्रिया",
      "EST":"एस्तोनिया",
      "ETH":"इथियोपिया",
      "FJI":"फिजी",
      "FIN":"फिनलैंड",
      "PYF":"फ्रेंच पॉलीनेशिया",
      "GAB":"गैबॉन",
      "GEO":"जॉर्जिया",
      "DEU":"जर्मनी",
      "GHA":"घाना",
      "GIB":"जिब्राल्टर",
      "GRC":"यूनान",
      "GRL":"ग्रीनलैंड",
      "GRD":"ग्रेनेडा",
      "GLP":"ग्वाडेलोप",
      "GTM":"ग्वाटेमाला",
      "GIN":"गिन्नी",
      "GNB":"गिन्नी -बिसाऊ",
      "HTI":"हैती",
      "HMD":"हेर्ड और मैकडोनाल्ड द्वीप समूह",
      "HND":"होंडुरस",
      "HUN":"हंगरी",
      "ISL":"आइसलैंड",
      "IND":"भारत",
      "IDN":"इंडोनेशिया",
      "IRL":"आयरलैंड",
      "ISR":"इजराइल",
      "ITA":"इटली",
      "JAM":"जमैका",
      "JPN":"जापान",
      "JOR":"जॉर्डन",
      "KAZ":"कजाखस्ता न",
      "KEN":"केन्या",
      "KIR":"किरिबाती",
      "KOR":"कोरिया गणतंत्र",
      "KWT":"कुवैत",
      "KGZ":"किर्गिजस्तान",
      "LVA":"लातविया",
      "LSO":"लिसोटो",
      "LBR":"लाइबेरिया",
      "LBY":"लीबिया",
      "LIE":"लिकटेंस्टीन",
      "LTU":"लिथुआनिया",
      "LUX":"लक्समबर्ग",
      "MAC":"मकाउ",
      "MDG":"मेडागास्कर",
      "MWI":"मलावी",
      "MYS":"मलेशिया",
      "MDV":"मालदीव",
      "MLI":"माली",
      "MLT":"माल्टा",
      "MHL":"मार्शल द्वीप समूह",
      "MTQ":"मार्टीनिक",
      "MUS":"मॉरीशस",
      "MYT":"मैयट",
      "MEX":"मेक्सिको",
      "MDA":"मोलदोवा",
      "MCO":"मोनाको",
      "MNG":"मंगोलिया",
      "MNE":"मोंटेनेग्रो",
      "MSR":"मोंटेसेराट",
      "MAR":"मोरक्को",
      "MOZ":"मोजाम्बिक",
      "NAM":"नामीबिया",
      "NRU":"नाउरू",
      "NLD":"नीदरलैंड",
      "NCL":"न्यू कैलेडोनिया",
      "NZL":"न्यूजीलैंड",
      "NIC":"निकारागुआ",
      "NER":"नाइजर",
      "NGA":"नाइजीरिया",
      "NIU":"नियू",
      "NFK":"नॉरफॉक द्वीप समूह",
      "NOR":"नॉर्वे",
      "OMN":"ओमान",
      "PAK":"पाकिस्तान",
      "PSE":"फिलिस्तीन",
      "PRY":"परागुआ",
      "PER":"पेरू",
      "PHL":"फिलीपींस",
      "PCN":"पिटकेर्न",
      "POL":"पोलैंड",
      "PRT":"पुर्तगाल",
      "QAT":"कतर",
      "ROU":"रोमानिया",
      "RUS":"रूस",
      "RWA":"रवांडा",
      "SHN":"सेंट हेलेना",
      "KNA":"संत किट्ट्स और नेविस",
      "LCA":"सेंट लूसिया",
      "SPM":"सेंट पियरे और मिकेलॉन",
      "VCT":"संत विंसेंट एंड दि ग्रेनडाइन्सर",
      "WSM":"समोआ",
      "SMR":"सैन मैरीनो",
      "STP":"साओ टोमे और प्रिंसिपे",
      "SAU":"सऊदी अरब",
      "SEN":"सेनेगल",
      "SRB":"सर्बिया",
      "SYC":"सेशेल्स",
      "SLE":"सियरा लिओन",
      "SGP":"सिंगापुर",
      "SVK":"स्लोवाकिया",
      "SVN":"स्लोवेनिया",
      "ZAF":"दक्षिण अफ्रीका",
      "ESP":"स्पेन",
      "SUR":"सूरीनाम",
      "SJM":"स्वालबार्ड और जैन मायेन",
      "SWZ":"स्वाजीलैंड",
      "SWE":"स्वीडन",
      "CHE":"स्विट्जरलैंड",
      "TJK":"तजाकिस्तान",
      "TZA":"तंजानिया",
      "THA":"थाईलैंड",
      "TLS":"तिमोर-लेस्ते",
      "TGO":"टोगो",
      "TON":"टोंगा",
      "TTO":"त्रिनिदाद और टोबैगो",
      "TUN":"ट्यूनीशिया",
      "TUR":"तुर्कस्तान",
      "TKM":"तुर्कमेनिस्तान",
      "TCA":"तुर्क और कैकज द्वीप समूह",
      "TUV":"तुवालु",
      "UKR":"यूक्रेन",
      "URY":"उरुग्वे",
      "UZB":"उज़्बेकिस्तान",
      "VUT":"वानुअतु",
      "VAT":"वेटिकन",
      "VEN":"वेनेजुएला",
      "VNM":"वियतनाम",
      "WLF":"वालिस और फ़्युटुना",
      "ESH":"पश्चिमी सहारा",
      "ZMB":"जाम्बिया",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia-Herzegovina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Lebanon",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua New Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "पता हेतु लाइन 1",
    "Addr2": "पता हेतु लाइन 2",
    "City": "कस्बा/ शहर",
    "Postcode": "पिनकोड",
    "Building_Name": "बिल्डिंग नंबर / नाम",
    "Street": "सड़क",
    "Province": "प्रांत",
    "birthDate": "जन्म तिथि",
    "birthYear": "वर्ष",
    "birthMonth": "माह",
    "birthSecond": "दिन",
    "Nationality": "राष्ट्रीयता",
    "isHavePass": "क्या आपके पास पासपोर्ट है",
    "PotSelect": {
      "havePot": "हाँ",
      "noPot": "नहीं"
    },
    "NAT_ID": "पासपोर्ट",
    "Phone": "फोन",
    "countryPlace": "करदाता जिस देश का निवासी है",
    "TIN": "टिन (करदाता पहचान संख्या)",
    "Doc_Type": "पहचान पत्र का प्रकार",
    "idTypeSelect": {
      "POT": "पासपोर्ट",
      "IDC": "पहचान पत्र",
      "DRI": "ड्राइविंग लाइसेंस"
    },
    "Doc_No": "पहचान पत्र संख्या",
    "bankCardType": "बैंक कार्ड का प्रकार",
    "bankCardTypeSelect": {
      "DR": "डेबिट कार्ड",
      "CR": "क्रेडिट कार्ड"
    },
    "Addr_Country":"पता देश",
    "Bank_Card_No": "बैंक नंबर",
    "bankCardNoConfirm": "बैंक नंबर की पुष्टि",
    "Bank": "बैंक",
    "bankSelect": {
      "ICBK": "इंडस्ट्रियल एंड कामर्शियल बैंक ऑफ चाइना",
      "ABOC": "एग्रीकल्चरल बैंक ऑफ चाइना",
      "PCBC": "चाइना कंस्ट्र्क्शन बैंक कारपोरेशन",
      "BKCH": "बैंक ऑफ चाइना लिमिटेड",
      "CMBC": "चाइना मर्चेन्ट्स बैंक",
      "COMM": "बैंक ऑफ कम्यूनिकेशन्स",
      "MSBC": "चाइना मिनशेंग बैंकिंग कारपोरेशन लिमिटेड",
      "EVER": "चाइना एवरब्राइट बैंक",
      "SPDB": "शांघाई पुडांग डेवलपमेंट बैंक",
      "FJIB": "इंडस्ट्रियल बैंक",
      "CIBK": "सिटिक बैंक कॉर्पोरेशन लिमिटेड",
      "PSBC": "पोस्टल सेविंग बैंक ऑफ चाइना",
      "SZCB": "शेन्जेन डेवलपमेंट बैंक कंपनी लिमिटेड",
      "GDBK": "चाइना गुंजाफा बैंक",
      "BOSH": "बैंक ऑफ शांघाई",
      "BJCN": "बैंक ऑफ बीजिंग",
      "HXBK": "ह्यूआ ज़िया बैंक",
      "other": "अन्य"
    },
    "OtherBank": "अन्य बैंक",
    "Beneficiary_Name": "लाभार्थी का नाम",
    "SWIFT_Code": "बैंक का स्विफ्ट कोड",
    "Branch_Name": "ब्रांच का नाम",
    "Bank_Addr": "ब्रांच का पता",
    "Branch_Province": "ब्रांच का प्रांत",
    "Branch_City": "ब्रांच का शहर",
    "bankCardImg": "बैंक कार्ड का इमेज",
    "IBAN_Code":"आईबीएएन कोडिंग",
    "docFrontImgword": "पहचान पत्र का इमेज (फ्रंट)",
    "docBackImgword": "पहचान पत्र का इमेज (बैक)",
    "addressUpload": "पते का सबूत",
    "addressUpload2": "पते का सबूत 2",
    "addressUploadTxt1": "उपलब्ध सबूत: बिजली/गैस बिल सूची/बैंक स्टेटमेंट/निवास परमिट/लाइसेंस/आईडी/ hukou, जो 3 महीने के अंदर के हों (यदि आवेदक, घर का मुखिया न हो, तो साथ में 1 पेज के प्रस्तुतिकरण में चित्र का विलय (मर्ज) करें);",
    "addressUploadTxt2": "पते का सबूत और पहचान प्रमाण पत्र दोनों एक ही न हों।",
    "docImgword1": "दस्तावेज अनुलग्नक 1",
    "docImgword2": "दस्तावेज संलग्नक 2",
    "docImgword3": "दस्तावेज संलग्नक 3",
    "docImgword4": "दस्तावेज संलग्नक 4",
    "docImgword5": "दस्तावेज संलग्नक 5",
    "fileUpload":{
      "imgtUpload": "अपलोड",
      "uploadFileArr": [{
        "labelTxt": "आईडी छवि 1",
        "ValidateNull": "कृपया चुनें",
        "sizeLimit": "ID Image1 5MB से अधिक नहीं हो सकता!"
      }, {
        "labelTxt": "आईडी छवि 2",
        "ValidateNull": "कृपया चुनें",
        "sizeLimit": "ID Image2 5MB से अधिक नहीं हो सकता!"
      }, {
        "labelTxt": "पते का सबूत",
        "ValidateNull": "कृपया चुनें",
        "sizeLimit": "पता का सबूत और पहचान पत्र का इमेज 5MB से अधिक न हो"
      },{
        "labelTxt": "पते का सबूत 2",
        "ValidateNull": "कृपया चुनें",
        "sizeLimit": "पता का सबूत और पहचान पत्र का इमेज 5MB से अधिक न हो"
      },{
        "labelTxt": "अन्य फ़ाइलें",
        "ValidateNull": "कृपया चुनें",
        "sizeLimit": "अन्य फाइलें 5 एमबी से अधिक नहीं हो सकती हैं!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"The file size cannot exceed 5MB",
        "upload_your_documents":"Upload Your Identity Documents",
        "documents_not_ready":"DOCUMENTS NOT READY?",
        "noe": "*Applicants must provide ID image and proof of address to verify their identity. We do not accept: mobile phone bills, credit card bills, or any mobile services bills; insurance receipts; invoice for purchased good/services.",
        "noe2":"You can still complete your application if you don't have the required documents right now. <br/><b>However, you will not be able to trade until we receive the required documents.<b/>",
        "header1": "Proof of Identity (Minimum requirement: $Logic)",
        "list1": "We require colour copies of the original government issued ID/passport document. For ID we require front and back sides of card.",
        "header2": "Proof of Address (Any $Logic of the following options)",
        "list2": "<ol class='list-style-position:inside'><li>Utility bill (water/electricity/gas) – issued in the past 3 months,</li><li>Bank Statement issued in the past 3 months,</li><li>We can accept residence books/property books including Chinese Hukou – but are subject to review.</li><li>A current rental agreement, and a supporting utility bill (gas/water/electricity), paid in previous 3 months, has to be provided.</li><li>A recent tax bill, if only issued in the past 6 months.</li><li>A landline Phone bill, issued in the past 3 month.</li></ol>",
        "strongTxt":"<strong>As part of our regulatory requirements, we may require additional documents in regards to your application.</strong>"
      }
    }
  },
  "financialDetails": {
    "Emp_Status": "रोजगार स्थिति",
    "employmentStatusSelect": {
      "b": "सेवारत",
      "a": "स्व-रोजगार",
      "c": "छात्र",
      "e": "अवकाश प्राप्त",
      "d": "बेरोजगार"
    },
    "Freelance_OwnACompany": "फ्रीलांस/कंपनी का मालिक",
    "Freelance_OwnACompany_select": {
      "0": "फ्रीलांस",
      "1": "कंपनी का मालिक"
    },
    "Position": "पद",
    "FD_Position_select": {
      "0": "सी ग्रेड मैनेजर अर्थात सीईओ, सीएफओ, सीआईओ",
      "1": "वरिष्ठ प्रबंधक",
      "2": "जनरल / मिडिल मैनेजर",
      "3": "सुपरवाईजर",
      "4": "क्लर्क",
      "5": "कर्मचारी",
      "6": "जूनियर",
      "7": "अन्य (कृपया निर्दिष्ट करें)"
    },
    "Employer": "व्यवसाय का नाम",
    "Biz_Nature": "व्यवसाय का स्वरूप",
    "financialRegulator": "आपके वित्तीय पोर्टफोलियो का मूल्य",
    "financialRegulatorSelect": {
      "Y": "हाँ",
      "N": "नहीं"
    },
    "Industry_Sector": "उद्योग/ क्षेत्र",
    "Industry_Sector_select": {
      "0":"लेखांकन",
      "1":"विज्ञापन/ मीडिया",
      "2":"कंप्यूटर/ इंटरनेट/ संचार/ इलेक्ट्रॉनिक्स",
      "3":"शिक्षा/ प्रशिक्षण",
      "4":"ऊर्जा/ कच्चा माल",
      "5":"वित्तीय सेवाएं (वित्त/ बैंकिंग/ बीमा)",
      "6":"सरकारी/ गैर-लाभकारी",
      "7":"मानव संसाधन",
      "8":"कानूनी",
      "9":"विपणन",
      "10":"लॉजिस्टिक/ परिवहन",
      "11":"औषधि/ चिकित्सा",
      "12":"प्रोफेशनल सर्विसेज",
      "13":"रियल एस्टेट/ निर्माण",
      "14":"सर्विस उद्योग",
      "15":"ट्रेड/ उपभोक्ता/ विनिर्माण/ संचालन",
      "16":"अन्य (कृपया निर्दिष्ट करें)"
    },
    "Annual_Income": "वार्षिक आय",
    "Annual_Income_word":"इसमें मजदूरी, पेंशन, ब्याज, लाभांश, किराए की आय आदि सहित सभी अर्जित आय शामिल हैं",
    "Total_Saving_Investments": "कुल बचत और निवेश",
    "Total_Saving_word": "इसमें सभी बैंक या ब्रोकरेज अकाउंट, प्रमाणपत्र, बांड, मनी मार्केट निवेश आदि शामिल हैं",
    "Total_Saving_Investments_select": {
      "0": "US$500 से अधिक",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "US$2,000 से कम"
    },
    "liquidNetWorth": "लिक्विड का शुद्ध मूल्य (निजी निवास को छोड़कर)",
    "financialPortfolio": "आपके वित्तीय पोर्टफोलियो का मूल्य",
    "annualIncomeSelect": {
      "0": "US$200,000 से अधिक",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "US$10,000 से कम"
    },
    "fundsSource": "इन फंडों का स्रोत",
    "fundsSourceSelect": {
      "0": "कोई नहीं",
      "1": "परिवार और पार्टनर की आय",
      "2": "सरकारी लाभ",
      "3": "ऋण/ क्रेडिट",
      "4": "पेंशन",
      "5": "संपत्ति आय",
      "6": "अन्य (कृपया निर्दिष्ट करें)"
    },
    "Funds_Source": "आय का अन्य स्रोत",
    "Intend_Deposit": "आपको कितना डिपॉजिट करना है?",
    "intendDepositSelect": {
      "0": "US$100,000 से अधिक",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "US$10,000 से कम"
    },
    "Other_Industry_Sector": "अन्य उद्योग / क्षेत्र",
    "Other_Position": "अन्य स्थिति",
    "Other_Biz_Nature": "व्यापार के अन्य प्रकृति",
    "Other_Funds_Source": "आय का अन्य स्रोत"
  },
  "Experience": {
    "experienceLabel": "पिछले तीन वर्षों में, आपने इन वित्तीय उपकरणों का किस सीमा तक ट्रेड किया है जिनमें आपने अपने स्वयं के ट्रेडिंग निर्णय लिए?",
    "Futures_Options": "वायदा / विकल्प",
    "Futures_Options_select": {
      "0": "40 से अधिक अवसरों पर",
      "1": "15 से 40 अवसरों पर",
      "2": "1 से 15 अवसरों पर",
      "3": "कभी नही"
    },
    "CFDs_Spread_Bets": "सीएफडी, फॉरेक्स एक्सचेंज डेरिवेटिव या स्प्रेड बेट्स",
    "CFDs_Spread_Bets_select": {
      "0": "40 से अधिक अवसरों पर",
      "1": "15 से 40 अवसरों पर",
      "2": "1 से 15 अवसरों पर",
      "3": "कभी नही"
    },
    "Derivative_Trade_over2": "पिछले बारह माह में, क्या आपने स्पॉट FX/ सीएफडी ऑप्शंस/ फ्यूचर्स या स्प्रेड बेट्स में प्रति तिमाही कम से कम दो ट्रेड किए, जहां आपने अपना खुद का ट्रेड निर्णय लिया हो?",
    "Derivative_Trade_over2_select": {
      "b": "हा",
      "a": "नही"
    },
    "Derivative_Trade_over40": "पिछले तीन वर्ष में, क्या आपने स्पॉट FX/ सीएफडी/ विकल्प/ फ्यूचर्स या स्प्रेड बेट्स में बारह माह की अवधि में चालीस ट्रेड किए?",
    "Derivative_Trade_over40_select": {
      "b": "हा",
      "a": "नही"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "क्या आपने कभी ऐसी पोजीशन में काम किया जहां डेरिवेटिव ट्रेडिंग के ज्ञान की जरूरत हो?",
    "DT_Work_Experience_select": {
      "txt1": "हां",
      "txt2": "नही",
      "subTxt1": "मुझे कम से कम 3 वर्ष का कार्य अनुभव है",
      "subTxt2": "मुझे 3 वर्ष से कम का कार्य अनुभव है या कम से कम एक वर्ष का अनुभव अपनी ओर से निवेश करने का रहा है।"
    },
    "DT_Qualification": "क्या आपके पास योग्यता है जिससे आपको डेरिवेटिव ट्रेडिंग की समझ मिली हो?",
    "DT_Qualification_select": {
      "txt1": "हां",
      "txt2": "नही",
      "subTxt1": "मेरे पास प्रोफेशनल योग्यता या सीएफए, एमबीए, बीएससी या एमए की डिग्री है",
      "subTxt2": "मेरे पास वित्त, अर्थशास्त्र, लेखा या इसी तरह के क्षेत्र में योग्यता या डिग्री है"
    },
    "K_Sell_Position": "यदि आपके पास सीएफडी में बिक्री पोजीशन हो और वर्तमान मूल्य आपकी बिक्री मूल्य से ऊपर है, तो क्या आप धन कमाएंगे या खो देंगे?",
    "K_Sell_Position_b": "यदि आपके पास सीएफडी में बिक्री पोजीशन हो और वर्तमान मूल्य आपकी बिक्री मूल्य से ऊपर है, तो क्या आप धन कमाएंगे या खो देंगे?",
    "K_Sell_Position_select": {
      "0": "हारेंगे",
      "1": "कमाएंगे"
    },
    "Closing_Order": "ट्रेडिंग करते समय नुकसान सीमित करने के लिए आप किस प्रकार का क्लोजिंग आर्डर चुनेंगे?",
    "Closing_Order_select": {
      "0": "स्टॉप लॉस",
      "1": "लाभ लें"
    },
    "K_Profit_Change": "100:1 की लिवरेज से सीएफडी और अन्य डेरिवेटिव की ट्रेडिंग करते समय, अंतर्निहित वित्तीय साधन के मूल्य में मामूली परिवर्तन आपके लाभ या हानि में असमान रूप से बड़ा फेरबदल कर सकता?",
    "K_Profit_Change_b": "100:1 की लिवरेज से सीएफडी और अन्य डेरिवेटिव की ट्रेडिंग करते समय, अंतर्निहित वित्तीय साधन के मूल्य में मामूली परिवर्तन आपके लाभ या हानि में असमान रूप से बड़ा फेरबदल कर सकता?",
    "K_Profit_Change_select": {
      "0": "हां",
      "1": "नहीं"
    },
    "K_Margin": "1 लॉट (100,000 USD/JPY, यदि आपका मार्जिन 1% है (लीवरेज 1:20) के लिए अपेक्षित मार्जिन क्या होगा",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "translation2.html:588 पुष्टि की जाती है कि आपको मैंने जो जानकारी दी है, वह सटीक और पूर्ण है तथा इस जानकारी में कोई परिवर्तन होने पर मैं आपको सूचित करने का वचन देता हूं।",
    "A2": "AT Global Markets द्वारा उपलब्ध ग्राहक अनुबंध मैंने पढ़ और समझ लिया है और मैं इसका पालन करने के लिए सहमत हूं।",
    "A2_txt": "AT Global Markets ग्राहक अनुबंध",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'> AT ग्लोबल मार्केट्स ग्राहक अनुबंध</a>",
    "A3": "AT Global Markets द्वारा उपलब्ध कराए गए जोखिम प्रकटीकरण कथन को मैंने पढ़ और समझ लिया है।",
    "A3_txt": "AT Global Markets जोखिम प्रकटीकरण कथन",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>AT Global Markets जोखिम प्रकटीकरण कथन </a>",
    "A4": "AT Global Markets द्वारा उपलब्ध कराए गए आर्डर एक्जीक्यूशन नीति और टकराव नीति को मैंने पढ़ और समझ लिया है।",
    "A4_txt": "AT Global Markets आर्डर एक्जीक्यूशन नीति और टकराव नीति",
    "A4_link": "<a https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>AT Global Markets आर्डर एक्जीक्यूशन नीति</a> तथा <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>टकराव नीति</a>",
    "headaer": "इस आवेदन को पूरा करके आप पुष्टि करते हैं कि आपको FX मार्जिन और CFD लिवरेज वाले प्रोडक्ट  की जानकारी है, जो आपकी निवेशित पूंजी के लिए भारी जोखिम पैदा करते हैं। आप यह भी पुष्टि करते हैं कि अपने अकाउंट पर नजर रखने की जिम्मेदारी आपकी है और उत्पादों की प्रकृति का मतलब है आपको मूल निवेश से अधिक नुकसान हो सकता है।",
    "age": "आप पुष्टि करते हैं कि आप की उम्र 18 वर्ष या इससे अधिक है;",
    "message": "इस आवेदन में दी गई जानकारी सत्य और सटीक है, इसमें किसी प्रकार का परिवर्तन होने पर आप हमें सूचित करने के लिए वचनबद्ध हैं;",
    "receive": {
      "text": "आपने पढ़ और समझ लिया है तथा सहमत हैं",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>बिजनेस की शर्तें और जोखिम चेतावनी</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>आर्डर एक्जीक्यूशन नीति</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>गोपनीयता नीति</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>इंट्रोड्यूसर ब्रोकर प्रकटीकरण</a>",
        "<a href='https://www.atfx.com/en/legal/?showEntity=uk'  target='_blank'>प्रमुख जानकारी वाले दस्तावेज</a>"
      ]
    },
    "A_select": {
      "text": "आपने पढ़ और समझ लिया है तथा सहमत हैं",
      "Y": "हाँ"
    },
    "checkboxTxt_A1": "मैंने सभी शर्तें पढ़ ली हैं, समझ ली हैं और सहमत हू",
    "checkboxTxt_A2": "मेरी जानकारी में सीएफडी लीवरेज उत्पाद हैं और उनका प्रदर्शन अस्थिर हो सकता है",
    "checkboxTxt_A3": "मेरी जानकारी में मेरे अकाउंट की निगरानी और उसे मैनेज करना मेरी ज़िम्मेदारी है",
    "checkboxTxt_A4": "मेरी जानकारी में लीवरेज किए गए उत्पादों की ट्रेडिंग करते समय मेरे प्रारंभिक निवेश से अधिक खोना संभव है",
    "Marketing_Email_Preference": "मैं एटीएफएक्स से जानकारी प्राप्त करने के लिए सहमत हूं जिसमें विपणन सामग्री हो सकती है।",
    "Marketing_Email_Preference_select":{
      "Y": "हाँ",
      "N": "नहीं"
    },
    "Hear_ATFX":"आपने एटीएफएक्स के बारे में कैसे सुना?",
    "OtherHearATFX":"दूसरा तरीका",
    "hearATFXSelect":{
      "Recommendation":"सिफ़ारिश करना",
      "SearchEngine":"खोज इंजन",
      "MediaAdvertising":"मीडिया विज्ञापन",
      "Partnership":"साझेदारी",
      "Other":"अन्य"
    },
    "Parent_IB_Code": "रेफरर कोड",
    "Rec_Type": "रेफरर का प्रकार",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "कोई रेफरर नहीं"
    },
    "recGroup": "रेफरर समूह",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "कृपया चुनें",
      "OtherGender":"कृपया एक और लिंग दर्ज करें",
      "Title": "कृपया चुनें",
      "OtherTitle":"कृपया एक और शीर्षक दर्ज करें",
      "First_Name": "पहला नाम",
      "Surname": "उपनाम",
      "Email": "ईमेल",
      "Email_Confirm": "ईमेल की पुष्टि",
      "Lang": "कृपया चुनें",
      "Country": "देश / क्षेत्र",
      "MT4_Currency":"कृपया चुनें",
      "Account_Type":"कृपया चुनें",
      "Addr": "पता",
      "Addr2": "पते की लाइन 2",
      "City": "शहर",
      "Postcode": "पिनकोड",
      "Building_Name": "बिल्डिंग नंबर / नाम",
      "Street": "सड़क",
      "Province": "प्रांत",
      "Birth_Date_Year": "जन्म तिथि",
      "Birth_Date_Month": "जन्म तिथि",
      "Birth_Date_Day": "जन्म तिथि",
      "Nationality": "राष्ट्रीयता",
      "isHavePass": "कृपया चुनें",
      "NAT_ID": "पासपोर्ट",
      "Phone": "फोन",
      "Doc_Type": "कृपया चुनें",
      "Doc_No": "पहचान पत्र संख्या",
      "Addr_Country": "कृपया चुनें",
      "Bank_Card_No": "बैंक संख्या",
      "Bank": "बैंक",
      "OtherBank": "अन्य बैंक",
      "Beneficiary_Name": "लाभार्थी का नाम",
      "Branch_Name": "ब्रांच का नाम",
      "Bank_Addr": "ब्रांच का पता",
      "Branch_Province": "ब्रांच का प्रांत",
      "Branch_City": "ब्रांच का शहर",
      "FD_Emp_Status": "कृपया चुनें",
      "FD_Position": "पद",
      "FD_Employer": "कंपनी का नाम",
      "FD_Biz_Nature": "कृपया बिजनेस की विशेषताएं दर्ज करें",
      "FD_FCA_AUTH": "कृपया",
      "FD_Annual_Income": "कृपया चुनें",
      "FD_Liquid_Net_Worth": "कृपया चुनें",
      "FD_Portfolio_Value": "कृपया चुनें",
      "FD_Funds_Source": "कृपया चुनें",
      "FD_Funds_Other": "कृपया चुनें",
      "E_Forex_Exp": "कृपया चुनें",
      "E_Forex_Trade_No": "कृपया चुनें",
      "E_Derivative_Exp": "कृपया चुनें",
      "E_Derivative_Trade_No": "कृपया चुनें",
      "E_Equity_Exp": "कृपया चुनें",
      "E_Equity_Trade_No": "कृपया चुनें",
      "K_A": "क्या आपने कभी ऐसे पद पर काम किया जिसमें डेरिवेटिव ट्रेडिंग का ज्ञान अपेक्षित था?",
      "K_A_Detail": "विवरण",
      "K_B": "क्या आपने डेरिवेटिव ट्रेडिंग के किसी प्रशिक्षण पाठ्यक्रम अथवा संगोष्ठी में भाग लिया है?",
      "K_B_Detail": "विवरण",
      "K_C": "क्या आपके पास कोई ऐसी योग्यता है, जिससे आपको डेरिवेटिव ट्रेडिंग की जानकारी हो?",
      "K_C_Detail": "विवरण",
      "K_D": "क्या आपको लिवरेज ट्रेडिंग के जोखिम और मैकेनिक्स तथा बुनियादी एसेट में मूल्य के हल्के-फुल्के उतार-चढ़ाव की जानकारी है, जो आपके निवेश के मूल्य में भारी उठा-पटक ला सकते हैं?",
      "K_E": "क्या आपको जानकारी है कि आपको आरंभिक निवेश से अधिक नुकसान हो सकता है?",
      "K_F": "क्या आपको जानकारी है कि ATFX हर लेनदेन में आपकी काउंटरपार्टी है और आपको हमारी फर्म के साथ अपनी पोजीशन बंद करनी होंगीं और वे हमारे क्रेडिट जोखिम के अधीन होंगे?",
      "K_G": "क्या आपको जानकारी है कि यदि मार्केट आपके प्रतिकूल चले, तो आपको अल्प समय के नोटिस पर अतिरिक्त मार्जिन डिपॉजिट करना पड़ सकता है और आवश्यक मार्जिन स्तर बनाए रखने में विफल होने पर आपकी पोजीशनें स्वत: बंद हो सकती हैं?",
      "K_H": "क्या आपको जानकारी है कि स्टॉप लॉस ऑर्डर आपके जोखिम को हमेशा सीमित नहीं करते हैं और मार्केट के तेजी से बढ़ने पर आप अपने स्टॉप मूल्य से परे स्लीपेज का अनुभव कर सकेंगे?",
      "A1": "translation2.html:588 पुष्टि की जाती है कि आपको मैंने जो जानकारी दी है, वह सटीक और पूर्ण है तथा इस जानकारी में कोई परिवर्तन होने पर मैं आपको सूचित करने का वचन देता हूं।",
      "A2": "AT Global Markets द्वारा उपलब्ध ग्राहक अनुबंध मैंने पढ़ और समझ लिया है और मैं इसका पालन करने के लिए सहमत हूं।",
      "A3": "AT Global Markets द्वारा उपलब्ध कराए गए जोखिम प्रकटीकरण कथन को मैंने पढ़ और समझ लिया है।",
      "A4": "AT Global Markets द्वारा उपलब्ध कराए गए आर्डर एक्जीक्यूशन नीति और टकराव नीति को मैंने पढ़ और समझ लिया है।",
      "checkList": "कृपया चुनें",
      "Emp_Status": "कृपया चुनें",
      "Freelance_OwnACompany": "कृपया चुनें",
      "Industry_Sector": "कृपया चुनें",
      "Position": "कृपया चुनें",
      "Employer": "कंपनी का नाम",
      "Biz_Nature": "कृपया बिजनेस की विशेषताएं दर्ज करें",
      "Annual_Income": "कृपया चुनें",
      "Total_Saving_Investments": "कृपया चुनें",
      "Funds_Source": "कृपया चुनें",
      "Intend_Deposit": "कृपया चुनें",
      "Other_Industry_Sector": "अन्य उद्योग / सेक्टर",
      "Other_Position": "अन्य स्थिति",
      "Other_Biz_Nature": "व्यापार के अन्य प्रकृति",
      "Other_Funds_Source": "आय के अन्य स्रोत",
      "Futures_Options": "कृपया चुनें",
      "CFDs_Spread_Bets": "कृपया चुनें",
      "Derivative_Trade_over2": "कृपया चुनें",
      "Derivative_Trade_over40": "कृपया चुनें",
      "DT_Work_Experience": "कृपया चुनें",
      "DT_Qualification": "कृपया चुनें",
      "K_Sell_Position": "कृपया चुनें",
      "Closing_Order": "कृपया चुनें",
      "K_Profit_Change": "कृपया चुनें",
      "K_Margin": "कृपया चुनें",
      "IBAN_Code":"कृपया आईबीएएन कोड दर्ज करें",
      "Hear_ATFX":"कृपया चुनें",
      "OtherHearATFX":"कृपया दर्ज करें",
      "Rec_Type":"कृपया चुनें",
      "Parent_IB_Code":"रेफरर कोड"
    }
  },
  "errors": {
    "fieldIsRequired": "ईमेल पता",
    "invalidFormat": "अमान्य प्रारूप!",
    "numberTooSmall": "संख्या बहुत कम है! न्यूनतम: {0}",
    "numberTooBig": "संख्या बहुत अधिक है! अधिकतम: {0}",
    "invalidNumber": "अमान्य संख्या",
    "textTooSmall": "टेक्स्ट की लंबाई बहुत कम है! वर्तमान: {0}, न्यूनतम: {1}",
    "textTooBig": "टेक्स्ट की लंबाई बहुत अधिक है! वर्तमान: {0}, न्यूनतम: {1}",
    "thisNotText": "यह कोई टेक्स्ट नहीं है!",
    "thisNotArray": "यह कोई श्रेणी नहीं है!",
    "selectMinItems": "न्यूनतम {0} आइटम चुनें!",
    "selectMaxItems": "अधिकतम {0} आइटम चुनें!",
    "invalidDate": "अमान्य तिथि!",
    "dateIsEarly": "तिथि बहुत जल्द की है! वर्तमान: {0}, न्यूनतम: {1}",
    "dateIsLate": "तिथि बहुत बाद की है! वर्तमान: {0}, अधिकतम: {1}",
    "invalidEmail": "ईमेल पता उपलब्ध नहीं है!",
    "invalidURL": "अमान्य URL!",
    "invalidCard": "अमान्य कार्ड प्रारूप!",
    "invalidCardNumber": "अमान्य कार्ड संख्या!",
    "invalidTextContainNumber": "अमान्य टेक्स्ट! इसमें नंबर या विशेष कैरेक्टर शामिल नहीं हो सकते हैं",
    "invalidTextContainSpec": "अमान्य टेक्स्ट ! इसमें नंबर या विशेष कैरेक्टर शामिल नहीं हो सकते हैं",
    "incorrectComfirm": "दो इनपुट असंगत हैं",
    "invalidBirthDate": "केवल 18-69 आयु वर्ग से आवेदन स्वीकार्य हैं",
    "invalidParentClnID": "कृपया 12 अंक से कम डिजीट दर्ज करें!",
    "docImgFrontSizeLimit": "पहचान पत्र का इमेज (फ्रंट) 2MB से अधिक न हो",
    "docImgBackSizeLimit": "पहचान पत्र का इमेज (बैक) 2MB से कम न हो",
    "imgSizeLimit": "पता का सबूत और पहचान पत्र का इमेज 2MB से अधिक न हो",
    "bankCardNoTopTwo": "बैंक कार्ड के पहले दो अंक लाइन से बाहर हैं",
    "bankCardNoLnegth": "कृपया 16-19 की संख्या दर्ज करें",
    "dayErrors1": "यह अधिवर्ष (लीप ईअर) है और इसमें कोई दिन नहीं है",
    "dayErrors2": "यह दिन इस वर्ष मौजूद नहीं है",
    "dayErrors3": "यह दिन इस माह मौजूद नहीं है",
    "emailError": "ईमेल पता उपलब्ध नहीं है",
    "DocTypeNoError": "पहचान पत्र संख्या अमान्य है",
    "DocFrontImg": "पहचान पत्र का इमेज अपलोड करें (फ्रंट)",
    "DocBackImg": "पहचान पत्र का इमेज अपलोड करें (बैक)",
    "ProofofAddress": "पते का सबूत अपलोड करें",
    "Doc_No": "पहचान पत्र संख्या",
    "Phone": "फोन",
    "Bank_Card_No": "बैंक संख्या",
    "Birth_Date_Second": "जन्म तिथि",
    "phoneError": "फोन का प्रारूप गलत है",
    "bankNumError": "बैंक संख्या का प्रारूप गलत है",
    "numType": "कृपया संख्या दर्ज करें",
    "bankCodeError":"आईबीएएन एन्कोडिंग प्रारूप गलत है"
  },
  "messages": {
    "fieldsWillBeReset": "सभी इनपुट रीसेट हो जाएंगे, कृपया पुष्टि करें",
    "completeTip1": "कृपया अपना ईमेल देखें। धन्यवाद।",
    "completeTip2": "पूर्ण हुआ! धन्यवाद।",
    "noCompleteTip": "खेद है, आपकी इनपुट जानकारी गलत है और उपरोक्त ऑपरेशन विफल रहा",
    "emailAndDocInvalid": "ईमेल पते का इस्तेमाल किया गया है",
    "phoneAndDocInvalid": "फोन नंबर का उपयोग किया गया है",
    "IBCodeInvalid": "रेफरर कोर्ड गलत है",
    "invalidBankCardNo": "बैंक कार्ड नंबर गलत है। इसे सबमिट करने से पहले जांच लें",
    "beneficiaryName": "लाभार्थी का नाम",
    "employerName": "नियोक्ता  का नाम",
    "errors": "नेटवर्क त्रुटियां",
    "unSelect":"कृपया चुनें",
    "selectEmpStatusTip":"जैसा कि आप रिटायर करने के लिए चुनते हैं, छात्रों और उच्च जोखिम वाले उत्पादों के लिए CFD उत्पादों में से एक बेरोजगार, अपने महत्वपूर्ण हितों की रक्षा के लिए, हम आप हमारे उत्पादों और सेवाओं के लिए उपयुक्त हैं कि क्या समीक्षा करने के लिए अपने अन्य सामग्री के आधार पर किया जाएगा"
  },
  "ModalMsg": {
    "showModal": {
      "content": "Based on the information you provided on your AT Global Markets Limited (UK) Limited client account application, it is necessary for us to inform you that trading in CFDs and leveraged forex may not be appropriate for you. Leveraged trading carries a high degree of risk to your capital. The Company provides an execution-‐‐only service to its clients and you will need to rely upon your own skill and judgement when trading these markets. <br/><br/><b>Please note: AT Global Markets (UK) Limited oﬀers demo accounts where you can practice trading against realistic market prices and the Company would encourage you to try this before trading with real money.</b><br/><br/>If you still wish to open a client account with AT Global Markets (UK) Limited, please conﬁrm this by accepting the statement below.",
      "checkboxTxt":"I understand that trading in CFDs and leveraged forex trading carries a high degree of risk to my capital. I am able to assess the risks involved and wish to continue with my application to open an account.",
      "errorsTxt": "Please tick the box",
      "btn": "की पुष्टि करें"
    },
    "showAlert": {
      "title": "टिप:",
      "submitBtnTxt": "की पुष्टि करें",
      "cancleBtnTxt": "रद्द करना",
      "confirmBtnTxt": "की पुष्टि करें"
    }
  },
  "ratesModalMsg": {
    "p3_1": "चेतावनी - सभी रिटेल ट्रेडर्स के लिए मार्जिन रेट परिवर्तन",
    "p3_2": "प्रिय आवेदक,",
    "p3_2_1": "",
    "p3_3": "कृपया ध्यान दें, यूरोपीय प्रतिभूति और बाजार प्राधिकरण (ईएसएमए) खुदरा व्यापारियों के लिए परिवर्तन के कारण, 2 जुलाई से सभी नए एटीएफएक्स ग्राहक नई मार्जिन दरों का उपयोग करेंगे।",
    "p3_4": "परिवर्तनों में खुदरा व्यापारियों को लीवरेज की मात्रा पर एक टोपी शामिल है।",
    "p4_1": "मेजर एफएक्स: मुद्रा जोड़े में निम्न में से कोई भी दो शामिल है: यूएसडी, यूरो, जेपीवाई, जीबीपी, सीएडी, सीएचएफ - 3.33% (लीवरेज 30: 1)",
    "p4_2": "माइनर एफएक्स: अन्य सभी मुद्रा जोड़े - 5% (लीवरेज 20: 1)",
    "p4_3": "प्रमुख सूचकांक: यूके 100, एफआर 40, ईएसपी 35, यूएस 30, एसपीएक्स 500, NAS100, जेपी 225, एयूएस200 5% (लीवरेज 20: 1)",
    "p4_4": "सोना: 5% (लीवरेज 20: 1)",
    "p4_5": "वस्तुओं: 10% (लीवरेज 10: 1)",
    "p5_1": "नकारात्मक संतुलन संरक्षण",
    "p5_2": "ईएसएमए ने यह सुनिश्चित करने के लिए एक नया नियम पेश किया है कि सभी खुदरा व्यापारी अपने खाते पर उपलब्ध धन से अधिक कभी नहीं खो सकते हैं। यदि आपकी शेष राशि नकारात्मक हो जाती है, तो एटीएफएक्स आपके बैलेंस को शून्य पर वापस लाने के लिए बाध्य होगा - आपके लिए कोई कीमत नहीं, ग्राहक।",
    "p5_3": "50% मार्जिन क्लोज-आउट नियम।",
    "p5_4": "एटीएफएक्स पहले से ही सभी ग्राहकों को 50% मार्जिन क्लोज आउट नियम प्रदान करता है।",
    "p5_5": "यदि आप अपने आवेदन को अंतिम रूप देना चाहते हैं और एटीएफएक्स खुदरा खाता खोलना चाहते हैं तो कृपया नीचे टिकटें।",
    "p5_6": "मैं खुदरा ग्राहकों के लिए नए नियमों को स्वीकार करता हूं और सहमत हूं",
    "p6_2": "कृपया सहमत हैं ",
    "btnText": "जमा करें"
  }
}



// WEBPACK FOOTER //
// ./src/lang/hi.js